import { trans } from '@lingoda/i18n';
import { format } from '@lingoda/dates';
import TextField from '../../fields/TextField';
import { useTheme } from '../../hooks';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { CalendarBlankIcon } from '../../icons/lingodaIcons';

interface Props {
    name: string;
    label: string;
    format?: string;
    disabled?: boolean;
    onClick: (ev: React.MouseEvent<HTMLDivElement>) => void;
    selectedDate?: Date;
}

export const CalendarInput = ({
    name,
    label,
    format: formatStr,
    disabled,
    onClick,
    selectedDate,
}: Props) => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    const getDisplayDate = () => {
        if (!selectedDate) {
            return '';
        }
        const formatMask = formatStr || 'PPP';

        return format(formatMask, selectedDate);
    };

    return (
        <TextField
            variant="outlined"
            name={name}
            label={label || trans('date-label', {}, 'public-common')}
            placeholder={label || trans('date-label', {}, 'public-common')}
            fullWidth
            onClick={disabled ? undefined : onClick}
            value={getDisplayDate()}
            InputProps={{
                disabled,
                endAdornment: (
                    <CalendarBlankIcon
                        size={isSmall ? 12 : 16}
                        color={theme.palette.primary.main}
                        style={isSmall ? { transform: 'translateX(6px)' } : undefined}
                    />
                ),
            }}
        />
    );
};
